<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <circle cx="8.5" cy="8.5" r="5.5" stroke="#E5E5E5" stroke-width="1.8"/>
  <circle cx="8.5" cy="8.5" r="3.2" stroke="#E5E5E5" stroke-width="1.1" stroke-dasharray="2 1.5"/>
</svg>
